<section class="space-y-4 p-1">
  @if (isLoadingSummary()) {
    <section
      class="rounded-2xl border border-slate-200 bg-white p-6 text-sm text-slate-500 shadow-sm dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300"
    >
      Calculando totales por método de pago...
      <div class="mt-2 h-1 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
        <div class="h-full w-1/2 animate-pulse bg-primary-500"></div>
      </div>
    </section>
  } @else {

    <div class="grid gap-4">
      <div class="space-y-4">
        @if (isCountStep) {
          <app-cash-session-payment-methods-table
            [rows]="previewRows()"
            [countedControls]="countedControls"
            [editableCounted]="true"
            [showIcons]="false"
            [showDifferenceLabel]="false"
            [title]="'Conteo por método de pago'"
            [subtitle]="'Ingresa la cantidad contada por cada método.'"
          ></app-cash-session-payment-methods-table>

          <div class="min-h-4 text-xs leading-tight text-rose-600 dark:text-rose-300">
            @if (countedInputsErrorMessage) {
              <p>
                {{ countedInputsErrorMessage }}
              </p>
            }
          </div>
        } @else {
          <div class="space-y-6 px-1 pt-1 sm:pt-2">
            <div class="space-y-4">
              <div class="flex items-center justify-between gap-3">
                <label
                  for="cash-session-cash-withdrawal-amount"
                  class="text-sm font-medium text-slate-700 dark:text-slate-200"
                >
                  Monto a retirar de la caja al cerrar el turno
                </label>

                @if (showSuggestedShortcut) {
                  <button
                    type="button"
                    class="text-sm font-medium text-primary-700 transition hover:text-primary-800 dark:text-primary-300 dark:hover:text-primary-200"
                    [disabled]="isSubmitting() || isLoadingSummary()"
                    (click)="useSuggestedCashWithdrawalAmount()"
                  >
                    Usar sugerencia
                  </button>
                }
              </div>

              <div class="w-full space-y-2">
                <div class="relative">
                  <span class="pointer-events-none absolute inset-y-0 left-4 flex items-center text-base font-medium text-slate-400 dark:text-slate-500 sm:left-5 sm:text-lg">
                    $
                  </span>
                  <input
                    id="cash-session-cash-withdrawal-amount"
                    type="number"
                    min="0"
                    step="0.01"
                    [formControl]="cashSessionForm.controls.cash_withdrawal_amount"
                    placeholder="0.00"
                    class="h-14 w-full rounded-2xl border border-slate-300 bg-white pl-10 pr-4 text-center text-2xl font-semibold text-slate-900 outline-none transition focus:border-primary-500 focus:ring-2 focus:ring-primary-100 dark:border-slate-600 dark:bg-slate-950 dark:text-white dark:focus:ring-primary-900/40 sm:h-16 sm:pl-12"
                  />
                </div>

                <p class="text-left text-xs text-slate-400 dark:text-slate-500">
                  Sugerencia: retirar {{ formatCurrency(suggestedCashWithdrawalAmount()) }}
                </p>
              </div>

              @if (cashSessionForm.controls.cash_withdrawal_amount.touched && cashSessionForm.controls.cash_withdrawal_amount.invalid) {
                <div class="mt-2 w-full text-left text-sm text-rose-600 dark:text-rose-300">
                  @if (cashSessionForm.controls.cash_withdrawal_amount.hasError('required')) {
                    <p>El efectivo que vas a retirar es requerido.</p>
                  } @else if (cashSessionForm.controls.cash_withdrawal_amount.hasError('min')) {
                    <p>El efectivo a retirar no puede ser negativo.</p>
                  } @else if (cashSessionForm.controls.cash_withdrawal_amount.hasError('cashWithdrawalExceedsCountedCash')) {
                    <p>{{ cashWithdrawalAmountErrors.cashWithdrawalExceedsCountedCash }}</p>
                  } @else if (cashSessionForm.controls.cash_withdrawal_amount.hasError('maxDecimals')) {
                    <p>{{ cashWithdrawalAmountErrors.maxDecimals }}</p>
                  }
                </div>
              }
            </div>

            <section class="rounded-2xl bg-slate-50 px-4 py-4 dark:bg-slate-950">
              <div class="flex items-start justify-between gap-4">
                <div>
                  <p class="text-sm font-medium text-slate-500 dark:text-slate-400">
                    Queda en caja
                  </p>
                  <p class="mt-2 text-2xl font-semibold text-slate-900 dark:text-white">
                    {{ formatCurrency(cashLeftAmount()) }}
                  </p>
                </div>
                <div class="text-right text-sm text-slate-500 dark:text-slate-400">
                  <p>
                    Contado:
                    <span class="text-lg font-semibold text-slate-800 dark:text-slate-100">
                      {{ formatCurrency(countedCashAmount()) }}
                    </span>
                  </p>
                  <p>
                    Retiro:
                    <span class="text-lg font-semibold text-slate-800 dark:text-slate-100">
                      {{ formatCurrency(cashSessionForm.controls.cash_withdrawal_amount.value || 0) }}
                    </span>
                  </p>
                </div>
              </div>
            </section>

            <div class="w-full">
              <label
                for="cash-session-close-notes"
                class="mb-1 block text-sm font-medium text-slate-900 dark:text-white"
              >
                Notas de cierre
              </label>

              <textarea
                id="cash-session-close-notes"
                [formControl]="cashSessionForm.controls.notes"
                maxlength="300"
                placeholder="Comentario  para registrar el cierre de caja"
                class="min-h-[88px] w-full resize-none overflow-y-auto rounded-lg border border-slate-300 bg-white px-3 py-2 text-slate-900 placeholder-slate-400 transition-colors duration-200 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-slate-600 dark:bg-slate-800 dark:text-white dark:placeholder-slate-500 sm:min-h-[64px]"
              ></textarea>
            </div>
          </div>
        }

      </div>
    </div>

    @if (isCashWithdrawalStep) {
      <div class="grid w-full gap-2 pt-2 sm:grid-cols-3">
        <app-button
          [label]="'Cancelar'"
          [variant]="'secondary'"
          [disabled]="isSubmitting() || isLoadingSummary()"
          [fullWidth]="true"
          (clicked)="close()"
        ></app-button>

        <app-button
          [label]="'Volver al conteo'"
          [variant]="'secondary'"
          [disabled]="isSubmitting() || isLoadingSummary()"
          [fullWidth]="true"
          (clicked)="goBackToMoneyCount()"
        ></app-button>

        <app-button
          [label]="'Cerrar caja'"
          [loadingLabel]="'Cerrando caja...'"
          [isLoading]="isSubmitting()"
          [disabled]="isSubmitting() || isLoadingSummary()"
          [fullWidth]="true"
          (clicked)="submit()"
        ></app-button>
      </div>
    } @else {
      <div class="grid w-full gap-2 pt-2 sm:grid-cols-2">
        <app-button
          [label]="'Cancelar'"
          [variant]="'secondary'"
          [disabled]="isSubmitting() || isLoadingSummary()"
          [fullWidth]="true"
          (clicked)="close()"
        ></app-button>

        <app-button
          [label]="'Confirmar conteo'"
          [icon]="'fa-solid fa-arrow-right'"
          [iconPosition]="'right'"
          [showLabelOnMobile]="true"
          [disabled]="isSubmitting() || isLoadingSummary()"
          [fullWidth]="true"
          (clicked)="confirmMoneyCount()"
        ></app-button>
      </div>
    }
  }
</section>
